import { VisuallyHidden } from '@mage-ui/components';
import { cx } from '@mage-ui/styled-system/css';
import { logoWrapper } from '@mage-ui/styled-system/recipes';

export const LogoWrapper = ({ logoData, className, children, ...rest }) => {
  return (logoData ?? logoData?.fields?.addressed_to) ? (
    <a
      href={logoData?.href ?? logoData?.fields?.url ?? '#'}
      className={cx(className, logoWrapper())}
      {...rest}
    >
      <VisuallyHidden>{logoData?.a11yLabel}</VisuallyHidden>
      {children}
    </a>
  ) : (
    <span className={cx(className, logoWrapper())} {...rest}>
      <VisuallyHidden>{logoData?.a11yLabel}</VisuallyHidden>
      {children}
    </span>
  );
};
